﻿'use strict';

angular.module('ntmApp').factory('ReportPrintingService', ['FlashService', '$timeout', function (FlashService, $timeout) {

    var service = {};

    var config = {
        headerCellBorder: [undefined, undefined, undefined, undefined],
        cellMargin: [5, 5, 5, 5],
        borderColor: '#e4e4e4',
        headerTextColor: '#fff',
        headerBackGroundColor: '#164166',
        evenCellColor: '#ecf6ff',
        fontSize: 13,
        headerColor: '#004987',
        headerFontSize: '24'
    };

    service.export = function (title, columns, data) {

        if (columns && data) {

            var loading = FlashService.Loading();

            $timeout(function () {

                var pdf = buildPdfDocument(title, data, columns);
                pdfMake.createPdf(pdf).download(title + '.pdf', function () {
                    loading.dismiss();
                });

            }, 300);
        }
    };

    function buildPdfDocument(title, data, columns) {

        var table = buildTable(data, columns);
        var header = buildHeader(title);

        var pdf = {
            pageSize: 'A4',
            pageOrientation: 'landscape'
        };

        if (header) {
            pdf.header = header;
        }

        pdf.content = [table];

        return pdf;
    }

    function buildHeader(title) {

        var headerColumns = [];

        var eSiriusIcon = getImgBase64UrlById('eSiriusLogoIcon');

        if (eSiriusIcon) {

            headerColumns.push({
                image: eSiriusIcon,
                fit: [100, 100],
                margin: [40, -10, 0, 0]
            });
        }

        if (title) {

            headerColumns.push({
                text: title,
                width: '70%',
                color: config.headerColor,
                fontSize: config.headerFontSize,
                alignment: 'left'
            });
        }

        if (headerColumns.length > 0) {

            return {
                margin: [0, 10, 0, 0],
                columns: headerColumns
            };
        }

        return null;
    }

    function buildTable(data, columns) {
        var tableObj = {
            table: {
                headerRows: 1,
                body: generateTableBody(data, columns)
            },

            layout: {
                hLineColor: function () {
                    return config.borderColor;
                },
                vLineColor: function () {
                    return config.borderColor;
                },
            }
        };

        if (columns.length <= 6) {
            tableObj.table.widths = columns.map(function () { return '*'; });
        }

        return tableObj;
    }

    function generateTableBody(rows, columns) {

        var body = [];

        body.push(generateHeaderCells(columns));

        rows.forEach(function (row, $rowIndex) {
            body.push(generateRow(row, $rowIndex, columns));
        });

        return body;
    }

    function generateHeaderCells(columns) {
        return columns.map(function (column) {
            return {
                text: column.displayName.trim(),
                fontSize: config.fontSize,
                color: config.headerTextColor,
                fillColor: config.headerBackGroundColor,
                border: config.headerCellBorder,
                margin: config.cellMargin
            };
        });
    }

    function generateRow(row, rowIndex, columns) {

        var dataRow = [];

        columns.forEach(function (column, $index) {

            var cell = {
                text: getRowValue(row, column),
                fontSize: config.fontSize,
                border: [
                    $index === 0 ? config.borderColor : undefined,
                    undefined,
                    $index === columns.length - 1 ? config.borderColor : undefined,
                    config.borderColor
                ],
                margin: config.cellMargin
            };

            if (rowIndex % 2 === 0) {
                cell.fillColor = config.evenCellColor;
            }

            dataRow.push(cell);
        });

        return dataRow;
    }

    function getRowValue(row, columnDef) {

        if (!row[columnDef.name] && columnDef.type !== 'boolean' && columnDef.type !== 'numeric') {
            return '';
        }

        if (columnDef.type === 'boolean') {
            return row[columnDef.name] === true ? 'Yes' : 'No';
        }

        if (columnDef.type === 'date') {
            return moment(row[columnDef.name]).format('MM/DD/YYYY');
        }

        return row[columnDef.name].toString();
    }

    function getImgBase64UrlById(id) {

        var imgToExport = document.getElementById(id);

        if (imgToExport) {
            var canvas = document.createElement('canvas');
            canvas.getContext('2d').drawImage(imgToExport, 0, 0);
            return canvas.toDataURL('image/png');
        }

        return '';
    }

    return service;

}]);